<template>
	<div class="aCustomSelect field" key="fieldname">


		<label :for="fieldname">{{label}} <span v-if="isRequired" class="req">*</span></label>

		<div class="dropdown" :class="{'open': isListOpen}">

			<input
			type="text"
			autocomplete="off"
			:id="fieldname"
			:placeholder="placeholder"
			v-model="textInField"
			@input="searchTextChanged"
			@keyup.prevent.down="down"
			@keyup.prevent.up="up"
			@keyup.enter="enter"
			@focus="turnAutoFillOff"
			@blur="turnAutoFillOn"
			:class="{hasError: isInError, hasSuccess: isInSuccess, isLoading: isLoading}"
			>

			<!-- Toggler -->
			<div class="toggle" @click="displaySuggestions(!isListOpen)">
				<span class="arrow-up" v-if="isListOpen">▲</span>
				<span class="arrow-down" v-if="!isListOpen">▼</span>
			</div>

			<!-- Suggestions list -->
			<ul class="suggestion-list">
				<li
				:class="{'active': currentActiveSuggestion === index}"
				v-for="(suggestion, index) in matches"
				:key="index"
				@click="selectSuggestion(suggestion, index)"
				>
				{{suggestion[1][description]}}
			</li>
		</ul>

	</div>

	<div class="errorMessage" v-if="isInError">{{errorMessage}}</div>
	<div class="helper">{{helper}}</div>

</div>
</template>

<!-- ================================================================================== -->

<script>
	import FormFields from "../mixins/FormFields";

	export default {
		name:"customSelect",

		mixins: [FormFields],

		props : {
			label : {
				type: String,
				required: true
			},
			dataFrom : {
				type: String,
				required: true
			},
			code : {
				type: String,
				required: true
			},
			description : {
				type: String,
				required: true
			},
			modelValue: {
				required: false,
				// This IS received in case of reparticipation…
			},
			isReparticipation: {
				type: Boolean,
				required: true,
			}
		},

		data(){
			return {
				isListOpen : false,
				options : [],
				searchText : "", // user input
				currentActiveSuggestion : 0, // not really reliable when one types the value, without using the list.
				errorMessage : '',
				autoFill : false,
			}
		},

		computed: {
			matches() {
				return Object.entries(this.options).filter((option) => {
					let optionText = option[1].[this.description].toUpperCase();
					return optionText.match(this.searchText.toUpperCase());
				});
			},

			textInField: {
				get(){
					let receivedId = this.modelValue;
					let categories = Object.keys(this.surveyQuestions);
					let description;


					categories.forEach((category) => {
						let result = this.surveyQuestions[category].find(obj => {
							return obj.id == receivedId;
						});
						if(result){
							description = result.description;
						}
					});

					return description;
				},
				set(){
					console.log("reset de textInField");
					this.searchText = "";
					return "";
				}
			},

			surveyQuestions() {
				if (this.$i18n.locale === "nl_BE"){
					return {
						// 418
						dryandwetfoodthesameday: [
						{id: '398', description: 'Ja'},
						{id: '399', description: 'Nee'}
						],
						// 419
						isitmainlydryandwetfood : [
						{id: '400', description: 'Droog'},
						{id: '401', description: 'Nat'},
						],
						// 420
						givepurinaoonedrycatfood: [
						{id: '402', description: 'Ja'},
						{id: '403', description: 'Nee'},
						],
						// 422
						givepurinaoonewetcatfood: [
						{id: '404', description: 'Ja'},
						{id: '405', description: 'Nee'},
						],
					};
				}else{
					return {
						dryandwetfoodthesameday: [
						{id: '398', description: 'Oui'},
						{id: '399', description: 'Non'}
						],
						isitmainlydryandwetfood : [
						{id: '400', description: 'Sèche'},
						{id: '401', description: 'Humide'},
						],
						givepurinaoonedrycatfood: [
						{id: '402', description: 'Oui'},
						{id: '403', description: 'Non'},
						],
						givepurinaoonewetcatfood: [
						{id: '404', description: 'Oui'},
						{id: '405', description: 'Non'},
						],
					};
				}

			}

		},

		methods: {

			turnAutoFillOff(){
				this.autoFill = false;
			},

			turnAutoFillOn(){
				this.autoFill = true;
			},

			getSuggestionsFromAPI () {
				this.setLoading();
				/* Not really connecting to the API. Data comes from surveyQuestions[] */
				this.options = this.surveyQuestions[this.dataFrom];
				console.log(this.options);
				this.setNotLoading();
			},

			displaySuggestions (bool) {
			// bool === true ? => open list
			// bool === false ? => close list

			if(bool){
				console.log("Open the list? " + bool);
				this.removeText();
				this.getSuggestionsFromAPI(); /* to "refresh" the content of the list following current locale */
				this.openList();
			}else{
				this.closeList();
			}
		},

		searchTextChanged () {
			if (!this.isListOpen) {
				this.openList();
			}
		},

		openList () {
			this.isListOpen = true;
			this.removeText();
		},

		closeList () {
			this.isListOpen = false;
		},

		removeText(){
			this.currentActiveSuggestion = '';
			this.searchText = "";
			this.textInField = "";
		},

		selectSuggestion (suggestion, index) {
			this.closeList();
			this.searchText = suggestion[1][this.description];
			this.$emit('update:modelValue', suggestion[1][this.code]);
			this.currentActiveSuggestion = index;
				// without checking
				this.sendCheckSignal(true);
			},

			up () {
				if(this.isListOpen && this.currentActiveSuggestion > 0){
					this.upOneItem();
				}else if(this.isListOpen){
					this.displaySuggestions(false);
					this.currentActiveSuggestion = 0;
				}
			},
			down () {
				if(this.isListOpen && this.currentActiveSuggestion < this.matches.length-1){
					this.downOneItem();
				}else if(!this.isListOpen){
					this.displaySuggestions(true);
					this.currentActiveSuggestion = 0;
				}
			},
			downOneItem () {
				if (this.currentActiveSuggestion < this.matches.length-1){
					this.currentActiveSuggestion += 1;
				}
			},
			upOneItem () {
				if(this.currentActiveSuggestion > 0){
					this.currentActiveSuggestion -= 1;
				}
			},
			enter () {

				/* currentActiveSuggestion is not updated when we press ENTER :( */


				let itemCode = this.matches[this.currentActiveSuggestion][1][this.code];
				this.searchText = this.matches[this.currentActiveSuggestion][1][this.description];
				this.$emit('update:modelValue', itemCode);

				this.displaySuggestions(false);

				if(this.checkIfImValid()){
					console.log("SelectInput says : 'my data are valid'");
				}else{
					console.log("SelectInput says : 'my data are invalid'");
				}
			},

			isThisFieldValid(){
				/* What is a valid answer ? An answer that is exactly in the list */
				let listSuggestions = [];
				for(let item in this.options){
					listSuggestions.push(this.options[item][this.description].toLowerCase());
				}
				return listSuggestions.includes(this.searchText.toLowerCase());
			},

			checkIfImValid(){
				console.log("I'm checking the validity of this field");
				if(this.isThisFieldValid()){
					console.log("This field " + this.fieldname + " IS valid.");
					this.giveSuccess();
				}else{
					console.log("This field " + this.fieldname + " IS NOT valid.");
					this.giveError();
				}
				console.log("Always TRUE because I'm a mockup");
				return true;
			},

			sendCheckSignal(bool){
				this.checkIfImValid();
				this.$emit('runCheck', {fieldname: this.fieldname, valid: bool});
			},

			sendDataToParent(){
				console.log("I send modelValue " + this.modelValue + " to parent");
				this.$emit('update:modelValue', this.modelValue);
				// as any answers is good here
				this.giveSuccess();
				this.$emit('runCheck', {fieldname: this.fieldname, valid: true});
			},

		},

		created() {
			this.getSuggestionsFromAPI();
			if(this.isReparticipation){
				this.sendDataToParent();
			}
		},
	}



</script>

<!-- ================================================================================== -->

<style lang="scss" scoped>



	.dropdown {
		display: inline-block;
		position: relative;
	}

	.suggestion-list {
		background-color: rgba(255, 255, 255, 0.95);
		border: 1px solid #ddd;
		list-style: none;
		display: block;
		margin: 0;
		padding: 0.5em;
		width: 100%;
		overflow: hidden;
		overflow-y:auto;
		position: absolute;
		top: 100%;
		left: 0;
		z-index: 2;
		max-height:15em;
	}

	.dropdown .suggestion-list {
		display: none;
	}

	.dropdown.open .suggestion-list {
		display: block;
	}

	.toggle {
		position: absolute;
		top:50%;
		transform:translateY(-50%);
		right:1em;
		cursor: pointer;
	}

	.toggle .arrow-up {
		display: none;
	}

	.open .toggle .arrow-up {
		display: inline-block;
	}

	.open .toggle .arrow-down {
		display: none;
	}

	.suggestion-list li {
		cursor: pointer;
		padding:0.25em;
	}

	.suggestion-list li:hover {
		color: #fff;
		background-color: #ccc;
	}

	li.active {
		background: #fc0;
	}

</style>
